import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useCallback, useEffect } from 'react';
import { getInitialCollaborationSidebarState, mergeCollaborationSidebarState } from '../utils/collaborationSidebarState';
import ControlledLayoutWithCollaborationSidebar from './ControlledLayoutWithCollaborationSidebar';
import { IS_OPEN, TAB } from 'collaboration-sidebar/constants/CollaborationSidebarStateProperties';
import { getSanitizedTab } from 'collaboration-sidebar/utils/tab';
import { isUngated } from '../utils/auth';
import { FLOATING_SIDEBAR_ALL } from '../constants/gates';
export default function LayoutWithCollaborationSidebar(_ref) {
  let {
    setToggleSidebar
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["setToggleSidebar"]);

  // When using ControlledLayoutWithCollaborationSidebar, the below logic
  // will have to be implemented manually.
  const [collaborationSidebarState, setCollaborationSidebarState] = useState(() => getInitialCollaborationSidebarState());
  const onUpdateCollaborationSidebarState = useCallback(updates => {
    setCollaborationSidebarState(state => mergeCollaborationSidebarState(state, updates));
  }, []);
  const floatingForAll = isUngated(FLOATING_SIDEBAR_ALL); // Give apps a way to open and close the sidebar from
  // outside the collaboration sidebar context by using
  // the callback in setToggleSidebar

  useEffect(() => {
    if (!setToggleSidebar) {
      return;
    }

    setToggleSidebar((isOpen = true, tab) => {
      onUpdateCollaborationSidebarState({
        [IS_OPEN]: isOpen,
        [TAB]: getSanitizedTab(tab)
      });
    });
  }, [onUpdateCollaborationSidebarState, setToggleSidebar]);
  return /*#__PURE__*/_jsx(ControlledLayoutWithCollaborationSidebar, Object.assign({}, props, {
    floating: floatingForAll || props.floating,
    isControlled: false,
    collaborationSidebarState: collaborationSidebarState,
    onUpdateCollaborationSidebarState: onUpdateCollaborationSidebarState
  }));
}